import '../vendor';

import '../general/ofi';
import '../general/search';
import '../general/hamburger';
import '../general/menu';
import '../general/breadcrumbs';
import '../general/anchor';
import '../general/full-screen';
import '../general/warning';
import '../general/up';

import '../pages/one-event/event-info-text';

import '../visually-impaired/open';
import '../visually-impaired/click';
import '../visually-impaired/size';
import '../visually-impaired/color';
import '../visually-impaired/length';
import '../visually-impaired/image';


// WEBPACK FOOTER //
// ./src/js/pages/one-event.js